(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.ses-anker-gallery').forEach((gallery) => {
      if (gallery.dataset.viewsReady) return;
      const list = gallery.querySelector('.product__media-list');
      const configurator = gallery.closest('.product__outer')?.querySelector('.ses-anker-configurator');
      if (!list || !configurator) return;
      gallery.dataset.viewsReady = 'true';
      configurator.addEventListener('change', () => requestAnimationFrame(() => {
        list.querySelector('.swiper-pagination-bullet')?.click();
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
